import { defaultApiState } from '../api.state';

export const widgetState = {
  apiState: {
    getWidgets: defaultApiState,
    getWidget: defaultApiState,
    deleteWidget: defaultApiState,
    addWidget: defaultApiState,
    updateWidget: defaultApiState,
  },
  widgets: [],
  widget: undefined,
};
